/**
 * @fileoverview TravelPage icons. JSON files in `public/icons/TravelPage/`.
 */
export const TRAVEL_ICONS = {
  travelDone: '/icons/TravelPage/ymsapbnv.json',
} as const;
